module.exports = "https://cdn.thelire.com/ins/resource/vip_video_arc.0a99138e24f7728eb4b7560125d66100.png";